import type {Route} from './nav.svelte';
/** Only public catalogue screens may mount without an account. No player or social side effects. */
export function guestCanBrowse(route:Route):boolean {
 return ['home','search','browse','collection','person','categories','title','notfound'].includes(route.name);
}
